import { CustomerDetailComp } from "../components/customerDetailComp"
import { GridLayout, HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout"
import { OrderComp } from "../components/orderComp"
import { SourceSessionComp } from "../components/sourceNSessionComp"
import { OrderProgressComp } from "../components/orderProgressComp"
import { CustomerOrdersComp } from "../components/customerOrdersComp"
import { useContext, useEffect, useState } from "react"
import { getAPI } from "../api/api"
import { Table } from "../components/table"
import { Spinner } from "../atoms/spinner"
import { CreditList, OrdersList } from "../components/orderslist"
import { StandardButton } from "../atoms/buttons"
import { icon } from "../functions/icons"
import { PayOrderOptions } from "../components/payOrderOptions"
import { HeaderTitle } from "../molecule/headerTitle"
import { BuyFeaturesComp } from "../components/buyFeaturesComp"
import { UserContext } from "../App"
import { padding } from "polished"

export const Orders = ({ pageSwap }) => {
    const [pageData, setPageData] = useState({ "currentPage": 5, "orderId": -1 })
   
    function setPage(page) {
        setPageData({ ...pageData, currentPage: page })
        if (page === 2) {
            loadCreditTotal()
        }

    }
    const [isLoading, setIsLoading] = useState(false);
    const [orders, setOrders] = useState({ order_details: [1], customer_details: [1], order_progress: [1], total_orders_business: [], total_credits: [] })

    useEffect(() => {
        if (pageData.currentPage == 0 || pageData.currentPage == 1) {

            loadOrders()

            setPageData({ ...pageData, currentPage: 1 })
        }
    }, [pageData.currentPage])

    async function openOrder(id) {
        setPageData({ currentPage: 2, orderId: id })
        const query = "api/orders/" + id
        const loadedOrders = await getAPI(query)
        setOrders(loadedOrders.data)
        setPageData((prevData) => ({ ...prevData, currentPage: 3 }))
    }

    const loadOrders = async () => {
        setIsLoading(true);
        const query = "api/orders"
        const load = await getAPI(query)
        const copyOrders = { ...orders }
        copyOrders.total_orders_business = load.data
        setOrders(copyOrders)
        setIsLoading(false);
    }
    const loadCreditTotal = async () => {
        setIsLoading(true);
        const query = "api/business/credits"
        const load = await getAPI(query)
        const copyOrders = { ...orders }
        copyOrders.total_credits = load.data
        setOrders(copyOrders)
        setIsLoading(false);
    }

    return (
        <VerticalPageLayout className={`page-in-animation ${pageSwap && "page-out-animation"}`}>
            <OrderFactory
                pageData={pageData}
                orders={orders}
                openOrder={openOrder}
                setPage={setPage}

            />

        </VerticalPageLayout>
    )
}


const OrderFactory = ({ pageData, orders, openOrder, setPage, isLoading }) => {
    console.log("orders", orders)
    const userInformation = useContext(UserContext)
    const isPublic = userInformation.account_type === 1
    switch (
    pageData.currentPage
    ) {

        case 1:
            return (
                <VerticalLayout style={{ padding: "2rem", boxSizing: "border-box" }}>
                    <HorizontalLayout>
                        <HeaderTitle title={isPublic ? "Functionaliteiten" : "Bestellingen"} />
                        <StandardButton onClick={() => setPage(5)} title="Bestelling plaatsen" />
                        {/* <StandardButton onClick={() => setPage(2)} title="Creditinzicht" /> */}
                    </HorizontalLayout>

                    <OrdersList isLoading={isLoading} orders={orders.total_orders_business} onOrderOpen={(id) => openOrder(id)}></OrdersList>
                </VerticalLayout>
            )
        case 2: return <></>
            // return (
            //     <VerticalLayout style={{padding: "2rem", boxSizing: "border-box" }}>
            //         <HorizontalLayout>
            //             <HeaderTitle title={"Creditverbruik inzicht"} />
            //             <StandardButton onClick={() => setPage(1)} title="Bestellingoverzicht" />
            //         </HorizontalLayout>

            //         <CreditList isLoading={isLoading} orders={orders.total_credits} onOrderOpen={(id) => openOrder(id)}></CreditList>
            //     </VerticalLayout>
            // )
        case 3:
            return (
                <VerticalLayout style={{padding: "2rem", boxSizing: "border-box" }}>
                    <HorizontalLayout style={{ gap: "1rem" }}>
                        <StandardButton style={{ marginLeft: 0 }} title={<>{icon("arrow-left")}</>} onClick={() => { setPage(1) }} />
                        <HeaderTitle title={`Bestelling #${orders.order_details[0].order_number}`} />
                    </HorizontalLayout>
                    <GridLayout className="order-grid standard-margin-top" columnsTemplate="2fr 1fr" gap="1rem">
                        <OrderComp order={orders.order_details[0]} customer={orders.customer_details} progress={orders.order_progress} />
                        <CustomerOrdersComp orders={orders.total_orders_business} />
                    </GridLayout>
                </VerticalLayout>
            )
        case 4:
            return (
                <VerticalLayout style={{ padding: "2rem", }}>
                    <HorizontalLayout className="title-pay-order" style={{ marginLeft: "1rem" }}>
                        <StandardButton style={{ marginLeft: 0 }} title={<>{icon("arrow-left")}</>} onClick={() => { setPage(1) }} />
                        <HeaderTitle className={"standard-padding"} title={"Bijbestellen"} />
                    </HorizontalLayout>
                    <PayOrderOptions />

                </VerticalLayout>
            )
        case 5:
            return (
                <>
                    <HorizontalLayout style={{margin:"2rem", marginBottom:"1rem", width:"unset"}}>
                        <HeaderTitle title={"Functionaliteiten overzicht"} />
                        <StandardButton onClick={() => setPage(1)} title="Bestellingoverzicht" />
                    </HorizontalLayout>
                    <BuyFeaturesComp />
                    </>
            )

        default: return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", "height": "100%" }}>
                <Spinner />
                <p className="standard-margin-top standard-text-color-light" style={{ "textAlign": "center" }}>
                    {pageData.currentPage == 0 ? "Even geduld, bezig met laden van bestellingen..." : "Even geduld, bezig met laden van bestelling..."}
                </p>
            </div>
        )
    }
}